import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_3xl,
  font_size_lg,
  font_size_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(6)};

  .NotificationDetails-title {
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
    font-size: ${font_size_3xl};
    line-height: 30px;
  }

  .NotificationDetails-description {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};

    .NotificationDetails-description-body {
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_lg};
      line-height: 20px;
    }
    .NotificationDetails-description-timestamp {
      color: ${text_colorTextSecondary};
      font-family: ${font_family_weight_regular};
      font-size: ${font_size_md};
      line-height: 18px;
    }
  }
`
